import React, {useState, useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import LocaleContext from '../../LocaleContext';
import ReCAPTCHA from 'react-google-recaptcha';
import {
    doc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { useSelector, useDispatch } from 'react-redux'
import Navbar2 from './Navbar2';
import { toast } from 'react-toastify'
import config from '../../config';
import { reset } from '../../features/auth/authSlice'

import Spinner from '../../components/Spinner'

var url = config.nav.url;
var retrieve_link = url+'retrievepassword';

var login_link = url+'login';
var model_submission_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_A_%20Proposition_Candidature.doc?alt=media&token=915393a8-d973-4428-8000-4861ff82ff41";
var cadre_logique_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_B_Cadre%20logique_et_Activit%C3%A9s.doc?alt=media&token=29acddf8-f138-4a9c-8ff4-9a0c1a9f25b9";
var submission_calendar = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_C_Calendrier_du_micro_projet.xlsx?alt=media&token=6f34a71d-8011-432f-895c-1a953dc44b73";
var budget_model_link = "https://firebasestorage.googleapis.com/v0/b/apafrep.appspot.com/o/Annexe_D_Budget.xlsx?alt=media&token=12dfc793-982f-4b26-ba2f-14a98f6929e9";

const Register = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    const [user, setUser] = useState({
        email : "",
        password : "",
        passwordConfirm : ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isCaptchaValidated, setCaptcha] = useState('');

    const { usr, isError, isSuccess, message } = useSelector(
        (state) => state.auth
      )

    useEffect(() => {
        // if(localStorage.getItem('user') != null){
        //     navigate('/');
        // }
        if (isError) {
        toast.error(message)
            window.alert('Erreur de connexion !')
        }

        if (isSuccess || usr) {
            navigate("/dashboard")
        }

    dispatch(reset())
  }, [user, isError, isSuccess, message, dispatch])
    
    function onCaptchaChange(value) {
        setCaptcha(value);
    }


    // Handle Inputs
    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        setUser({...user, [name]:value});
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        
        event.preventDefault();
        setIsLoading(true);
        const {email, password, passwordConfirm} = user;
        
        if (password !== passwordConfirm) {
            toast.error('Passwords do not match')
            window.alert('Passwords do not match')
            setIsLoading(false);
          } else {
            const userData = {
              email,
              password,
            }

            try {
                const res = await createUserWithEmailAndPassword(
                    auth,
                    userData.email,
                    userData.password
                  );
                  await setDoc(doc(db, "users", res.user.uid), {
                    ...userData,
                    type: 'candidate',
                    timeStamp: serverTimestamp(),
                  }).then((userCredential) => {
                    // Signed in
                    localStorage.setItem("id", res.user.uid);
    
                    dispatch({type:"LOGIN", payload:res.user})
                    navigate("/dashboard")
                });
            } catch (error) {
                setIsLoading(false);
                if(error.toString().includes("email-already-in-use")){
                    window.alert("Cette adresse email est déjà utilisée !")
                }
                else{
                    window.alert(error)
                }
            }
          }
    }

    if (isLoading) {
        return <Spinner />
      }

    return (
        <div>
            <Navbar2/>
            <div className="container m-5">
            <div className="row">
                    <div className='col-md-6 '>
                        <div className="row justify-content-end cadre">
                            <div className="col-md-4 mt-5 pt-4">
                                <img className="w-100" src="/assets/logo.png" alt="About"/>
                            </div>
                            <div className="col-md-7">
                                <h1 className="display-6 mt-3 pt-5">{t('create_account')}</h1>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('email_address')}</label>
                                        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="email" value ={user.email} onChange={handleInput}/>
                                    </div>
                                    <div className="mb-2">
                                    <label htmlFor="exampleInputPassword1" class="form-label">{t('password')}</label>
                                        <input type="password" class="form-control" id="exampleInputPassword1" 
                                        name="password" value ={user.password} onChange={handleInput}/>
                                    </div>
                                    <div className="mb-2">
                                    <label htmlFor="exampleInputPassword1" class="form-label">{t('confirm_password')}</label>
                                        <input type="password" class="form-control" id="exampleInputPassword2" 
                                        name="passwordConfirm" value ={user.passwordConfirm} onChange={handleInput}/>
                                    </div>
                                    <div className="App">
                                        <ReCAPTCHA
                                            sitekey="6LduT5AjAAAAACyI7WpCCyyUagByTLRhvHyMMMGu"
                                            lang={locale}
                                            onChange={onCaptchaChange}
                                        />
                                    </div>
                                    <button disabled={isCaptchaValidated.length < 1 } type="submit" class="btn btn-outline-primary mt-2 mb-2">{t('save')}</button>
                                    <p>{t('user_already')} <NavLink to={login_link} className="deco_null">{t('log_in')}</NavLink>.</p>
                                </form>
                            </div>
                        </div>
                        <div className="row cadre mt-4">
                            <p>{t('resources')}</p>
                            <div className="col-md-5">
                                <ul>
                                    <li><a href={model_submission_link} target="_blank" rel="noopener noreferrer">{t('text_6_1')};</a></li>
                                    <li><a href={cadre_logique_link} target="_blank" rel="noopener noreferrer">{t('text_6_2')};</a></li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <ul>
                                    <li><a href={budget_model_link} target="_blank" rel="noopener noreferrer">{t('text_6_3')};</a></li>
                                    <li><a href={submission_calendar} target="_blank" rel="noopener noreferrer">{t('text_6_4')};</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 pl-4">
                        <h4 className="fw-bolder mb-4">{t('login_welcome')}</h4>
                        <p className="lead fs-2">{t('login_title')}</p>
                        <p>{t('register_text_1')}.</p>
                        <p>{t('register_text_2')}, <NavLink to={login_link} className="deco_null">{t('register_text_3')}</NavLink>, {t('register_text_4')} <NavLink to={retrieve_link} className="deco_null">{t('forgot_password')}</NavLink>.</p>
                        <p className='fw-bolder'>Contacts</p>
                        <p>{t('login_text_6')} <a href='mailto:ngatchou_alban@yahoo.fr'>ngatchou_alban@yahoo.fr</a></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register;
